// extracted by mini-css-extract-plugin
module.exports = {"block":"_361","list":"_32","more":"_11694","arrow":"_12492"};